import React from 'react'
import { useSelector } from 'react-redux'
import Modal from '~/components/common/modal'

import { translate } from '~/core/translate'
import { getDialogProps } from '~/selectors/ui'
import { RESOURCE_TYPE_MAPPINGS } from './configs'
import LinksWrapper from './links-wrapper'

const LinksDialog = () => {
  const { id, resourceType } = useSelector(getDialogProps)
  const resourceTypeData = RESOURCE_TYPE_MAPPINGS[resourceType]

  return (
    <Modal title={translate(resourceTypeData.titleTranslateKey)}>
      <LinksWrapper resourceType={resourceType} id={id} />
    </Modal>
  )
}

export default LinksDialog
